module.exports = __webpack_public_path__ + "img/lightmode_woods.1af60e52.png";